module.exports = __webpack_public_path__ + "img/koishi komeiji.19ddcdb5.png";